import React from 'react';
import { motion } from 'framer-motion';
export function Mission() {
  return <section className="w-full bg-navy-primary py-20 px-4" data-id="element-152">
      <div className="max-w-4xl mx-auto" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-154">
          <blockquote className="text-xl md:text-2xl text-white leading-relaxed italic mb-8" data-id="element-155">
            "เราสร้างระบบนี้เพื่ออาจารย์สอนฟุตบอลไทย
            ที่ทำงานหนักแต่ยังไม่เห็นผลลัพธ์ที่ต้องการ
            <br data-id="element-156" />
            <br data-id="element-157" />
            ไม่มีทฤษฎี ไม่มีที่ปรึกษาราคาแพง มีแต่เครื่องมือที่ใช้งานได้จริง
            เพื่อให้คุณสอนฟุตบอลได้อย่างมืออาชีพอย่างแท้จริง"
          </blockquote>
          <p className="text-gold-accent font-bold text-xl" data-id="element-158">
            — ทีมงาน ฟุตบอล พร้อม
          </p>
        </motion.div>
      </div>
    </section>;
}